import React from "react";
import { Link } from "react-router-dom";
import {
  FaBuilding,
  FaUsers,
  FaHandshake,
  FaGavel,
  FaLaptopCode,
  FaLeaf,
} from "react-icons/fa";

const COLORS = {
  bg: "#000000",          // pure black
  card: "#111111",        // matte black
  gold: "#D4AF37",        // premium gold
  goldSoft: "rgba(212,175,55,0.5)",
  textMuted: "#A0A0A0",
};

const PracticeAreas = () => {
  const practices = [
    {
      title: "Civil Matters",
      desc: "Expert handling of property disputes, contracts, and ownership conflicts.",
      icon: <FaBuilding />,
      link: "/services/civil-cases",
      size: "lg:col-span-2",
    },
    {
      title: "Criminal Law",
      desc: "Strategic defense in bail and white-collar crimes.",
      icon: <FaGavel />,
      link: "/services/criminal-cases",
      size: "lg:col-span-1",
    },
    {
      title: "Matrimonial",
      desc: "Confidential support in divorce and child custody.",
      icon: <FaUsers />,
      link: "/services/matrimonial-Cases",
      size: "lg:col-span-1",
    },
    {
      title: "Commercial",
      desc: "Business advisory and regulatory compliance.",
      icon: <FaHandshake />,
      link: "/services/commercial-disputes",
      size: "lg:col-span-2",
    },
    {
      title: "Cyber Law",
      desc: "Protection against fraud and data theft.",
      icon: <FaLaptopCode />,
      link: "/services/cyber-cases",
      size: "lg:col-span-1",
    },
    {
      title: "Environmental",
      desc: "Compliance and NGT litigation support.",
      icon: <FaLeaf />,
      link: "/services/environmental-matters",
      size: "lg:col-span-1",
    },
  ];

  return (
    <section style={{ background: COLORS.bg }} className="py-24 px-6 md:px-16">
      <div className="max-w-7xl mx-auto">

        {/* Header */}
        <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
          <div className="max-w-2xl">
            <span
              className="uppercase tracking-[5px] text-xs font-bold block mb-3"
              style={{ color: COLORS.gold }}
            >
              Our Expertise
            </span>

            <h2 className="text-4xl md:text-6xl font-serif text-white">
              Legal{" "}
              <span style={{ color: COLORS.gold }} className="italic">
                Excellence
              </span>
            </h2>
          </div>

          <p className="max-w-xs text-sm" style={{ color: COLORS.textMuted }}>
            Delivering strategic legal solutions with precision, discretion, and unmatched expertise.
          </p>
        </div>

        {/* Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {practices.map((item, idx) => (
            <Link
              key={idx}
              to={item.link}
              className={`group relative overflow-hidden rounded-2xl ${item.size}`}
            >
              {/* Card */}
              <div
                className="relative h-full p-8 md:p-10 flex flex-col justify-between border transition-all duration-500 group-hover:-translate-y-2"
                style={{
                  background: COLORS.card,
                  borderColor: "rgba(255,255,255,0.06)",
                }}
              >
                <div>
                  {/* Icon */}
                  <div
                    className="w-12 h-12 flex items-center text-white justify-center rounded-full mb-6 border transition-all duration-500 group-hover:bg-[#D4AF37] group-hover:text-black"
                    style={{
                      borderColor: COLORS.goldSoft,
                    }}
                  >
                    {item.icon}
                  </div>

                  {/* Title */}
                  <h3 className="text-xl md:text-2xl font-semibold text-white mb-3">
                    {item.title}
                  </h3>

                  {/* Desc */}
                  <p className="text-sm leading-relaxed" style={{ color: COLORS.textMuted }}>
                    {item.desc}
                  </p>
                </div>

                {/* Bottom CTA */}
                <div className="mt-8 flex items-center justify-between">
                  <span
                    className="text-xs uppercase tracking-widest font-semibold opacity-0 group-hover:opacity-100 transition"
                    style={{ color: COLORS.gold }}
                  >
                    View Details
                  </span>

                  <div
                    className="w-8 h-8 flex items-center text-white justify-center rounded-full border transition-all duration-300 group-hover:bg-[#D4AF37] group-hover:text-black"
                    style={{
                      borderColor: "rgba(255,255,255,0.2)",
                     
                    }}
                  >
                    →
                  </div>
                </div>

                {/* Glow */}
                <div
                  className="absolute inset-0 opacity-0 group-hover:opacity-10 blur-2xl transition"
                  style={{ background: COLORS.gold }}
                />
              </div>

              {/* Top Gold Line */}
              <div
                className="absolute top-0 left-0 h-[2px] w-0 group-hover:w-full transition-all duration-500"
                style={{ background: COLORS.gold }}
              />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default PracticeAreas;